import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from '../utils/api';
const AuthContext = createContext(null);
export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) { auth.me().then((r) => setUser(r.data)).catch(() => localStorage.removeItem('token')).finally(() => setLoading(false)); }
    else { setLoading(false); }
  }, []);
  const login = async (email, password) => { const r = await auth.login(email, password); localStorage.setItem('token', r.data.access_token); setUser({ email: r.data.email }); return r.data; };
  const logout = () => { localStorage.removeItem('token'); setUser(null); };
  return <AuthContext.Provider value={{ user, loading, login, logout }}>{children}</AuthContext.Provider>;
}
export const useAuth = () => useContext(AuthContext);
